/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * Paginated list of tournaments
 * @export
 * @interface TournamentsListResponse
 */
export interface TournamentsListResponse {
    /**
     * 
     * @type {Array<Tournament>}
     * @memberof TournamentsListResponse
     */
    tournaments: Array<Tournament>;
    /**
     * Total number of matching tournaments
     * @type {number}
     * @memberof TournamentsListResponse
     */
    total: number;
    /**
     * Page size
     * @type {number}
     * @memberof TournamentsListResponse
     */
    limit: number;
    /**
     * Pagination offset
     * @type {number}
     * @memberof TournamentsListResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the TournamentsListResponse interface.
 */
export function instanceOfTournamentsListResponse(value: object): value is TournamentsListResponse {
    if (!('tournaments' in value) || value['tournaments'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function TournamentsListResponseFromJSON(json: any): TournamentsListResponse {
    return TournamentsListResponseFromJSONTyped(json, false);
}

export function TournamentsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournaments': ((json['tournaments'] as Array<any>).map(TournamentFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function TournamentsListResponseToJSON(json: any): TournamentsListResponse {
    return TournamentsListResponseToJSONTyped(json, false);
}

export function TournamentsListResponseToJSONTyped(value?: TournamentsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournaments': ((value['tournaments'] as Array<any>).map(TournamentToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

